import { PZStatus } from '../../types/pz';
import { WZStatus } from '../../types/wz';

export const PZ_OPERATIONAL_STATUSES = [
  PZStatus.DRAFT,
  PZStatus.RECEIVED,
  PZStatus.CANCELLED,
] as const;

/** Historical CONFIRMED rows are still editable drafts in the simplified flow. */
export function getPZOperationalStatus(status: PZStatus): PZStatus {
  return status === PZStatus.CONFIRMED ? PZStatus.DRAFT : status;
}

/** Historical RECEIVED WZ rows represent a completed issue to the operator. */
export function getWZOperationalStatus(status: WZStatus): WZStatus {
  return status === WZStatus.RECEIVED ? WZStatus.RELEASED : status;
}
